<template>
    <v-dialog v-model="dialog" max-width="40%" @keydown.esc="cancel">
        <v-card>
            <v-card-title class="headline">
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>
                    {{ p1 }}
                </p>
                <p>
                    {{ p2 }}
                </p>
            </v-card-text>
            <v-card-actions>
                <v-btn class="col" text @click="dialog = false">
                    {{ $t('actions.reseller.notifyCustomers.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="save"
                    :loading="saving"
                >
                    {{ $t('actions.reseller.notifyCustomers.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Reseller from '@/models/Reseller'

export default {
    data: () => {
        return {
            dialog: false,
            resellerId: undefined,
            value: false,
            saving: false,
        }
    },

    computed: {
        title() {
            return this.value
                ? this.$t('actions.reseller.notifyCustomers.title')
                : this.$t('actions.reseller.notifyCustomers.title2')
        },
        p1() {
            return this.value
                ? this.$t('actions.reseller.notifyCustomersAll.p1')
                : this.$t('actions.reseller.notifyCustomersAll.p3')
        },
        p2() {
            return this.value
                ? this.$t('actions.reseller.notifyCustomersAll.p2')
                : this.$t('actions.reseller.notifyCustomersAll.p4')
        },
        success() {
            return this.value
                ? this.$t('actions.reseller.notifyCustomersAll.success')
                : this.$t('actions.reseller.notifyCustomersAll.success2')
        },
    },

    methods: {
        open({ id, value }) {
            this.resellerId = id
            this.value = value
            this.dialog = true
        },

        async save() {
            if (!this.resellerId) {
                this.dialog = false
                return
            }

            this.saving = true
            try {
                const model = new Reseller()
                const url = `${model.resourceUrl()}${
                    this.resellerId
                }/notify-customers`
                const res = await this.$http.put(url, {
                    all: true,
                    notify_customers: this.value,
                })

                if (!res) return

                this.$emit('modelChanged')
                this.$bus.$emit('notify', 'success', this.success)
            } finally {
                this.saving = false
                this.dialog = false
            }
        },
    },
}
</script>

<style></style>
